
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class VideoIcon extends Vue {}
